<template>
    <q-card class="relative-position full-height">
        <q-card-title>
            {{ from_home ? $t('questions') : $t(this.type_chat) }}
        </q-card-title>

        <q-card-separator />

        <q-card-main :style="from_home ? getStyleMain : ''">
            <q-scroll-area :style="from_home ? getStyleScroll : 'height: 400px;'">
                <q-chat-message
                    v-for="(chat, index) in chats"
                    :key="index"
                    :name="chat.n"
                    :text="[chat.m]"
                    :stamp="fDate(chat.t.toDate())"
                    :bg-color="!chat.a ? colors[index % 6] : 'tertiary'"
                    text-color="white"
                    @click.native="actOnChat(chat)"
                    :sent="chat.a ? true : false"
                />
            </q-scroll-area>
        </q-card-main>

        <q-inner-loading :visible="!loaded">
            <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
        </q-inner-loading>
    </q-card>
</template>

<script>
import { db } from 'plugins/vuefire'
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['id_webcast', 'type_chat', 'order', 'from_home'],

    data() {
        return {
            chats: [],
            loaded: false,
            colors: ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue'],
            style: ''
        }
    },

    computed: {
        ...mapGetters({
            video_height: 'webcasts/video_height'
        }),

        getStyleMain() {
            if (this.$q.platform.is.mobile) return ''
            else return `height: 90%;`
        },

        getStyleScroll() {
            if (this.$q.platform.is.mobile) return 'height: 300px; overflow-x: hidden;'
            else return `height: 90%; overflow-x: hidden;`
        }
    },

    methods: {
        fDate(date_raw) {
            return date.formatDate(date_raw, 'DD/MM/YYYY HH:mm:ss')
        },

        actOnChat(chat) {
            this.$emit('click_chat', chat, this.type_chat)
        }
    },

    watch: {
        id_webcast: function() {
            if (this.id_webcast != 0) {
                this.$bind('chats', db.collection('webcast_chat').doc(this.id_webcast.toString()).collection(this.type_chat).orderBy(this.order, 'desc')).then(chats => {
                    this.chats === chats
                })
                .then(()=> {
                    this.loaded = true
                })
            }
        }
    },

    created() {
        if (this.id_webcast != 0) {
            this.$bind('chats', db.collection('webcast_chat').doc(this.id_webcast.toString()).collection(this.type_chat).orderBy(this.order, 'desc')).then(chats => {
                this.chats === chats
            })
            .then(()=> {
                this.loaded = true
            })
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>
